module.exports = "<img [hidden]=\"!item.HasPicture()\" [src]=\"imageUrl\" />\n"